module.exports = __webpack_public_path__ + "img/矩形-白色@2x.8331a9d2.png";